import { useMemo, useState } from 'react';
import { Button, Divider, Drawer, Flex, Space, Typography } from 'antd';
import DatePickerMobile from '@/components/date-picker/mobile';
import dayjs from 'dayjs';

const { Text } = Typography;

const DateRangePickerMobile = ({ props, viewModel }) => {
  const [open, setOpen] = useState(false);
  const [showCustom, setShowCustom] = useState(false);
  const [customStart, setCustomStart] = useState(null);
  const [customEnd, setCustomEnd] = useState(null);

  const { presets } = viewModel;
  const { value, onChange, format, disabled, ...datePickerProps } = props;

  const displayFormat = Array.isArray(format) ? format[0] : format || 'DD/MM/YY';

  const label = useMemo(() => {
    if (!value || !Array.isArray(value) || !value[0] || !value[1]) {
      return 'Chọn ngày';
    }

    return `${dayjs(value[0]).format(displayFormat)} - ${dayjs(value[1]).format(displayFormat)}`;
  }, [displayFormat, value]);

  const onSelectPreset = (presetValue) => {
    if (!onChange) {
      return;
    }

    onChange(presetValue);
    setOpen(false);
    setShowCustom(false);
  };

  const onApplyCustom = () => {
    if (!onChange || !customStart || !customEnd) {
      return;
    }

    if (customEnd.isBefore(customStart, 'day')) {
      return;
    }

    onChange([customStart.startOf('D'), customEnd.endOf('D')]);
    setOpen(false);
    setShowCustom(false);
  };

  const onClose = () => {
    setOpen(false);
    setShowCustom(false);
  };

  const onOpenCustom = () => {
    setShowCustom(true);
    setCustomStart(value?.[0] ? dayjs(value[0]) : null);
    setCustomEnd(value?.[1] ? dayjs(value[1]) : null);
  };

  const disableStartDate = (currentDate) => {
    if (!customEnd || !currentDate) {
      return false;
    }

    return currentDate.isAfter(customEnd, 'day');
  };

  const disableEndDate = (currentDate) => {
    if (!customStart || !currentDate) {
      return false;
    }

    return currentDate.isBefore(customStart, 'day');
  };

  const onOpen = () => {
    setOpen(true);
    setShowCustom(false);
    setCustomStart(value?.[0] ? dayjs(value[0]) : null);
    setCustomEnd(value?.[1] ? dayjs(value[1]) : null);
  };

  return (
    <>
      <Button onClick={onOpen} disabled={disabled}>
        {label}
      </Button>

      <Drawer title='Chọn ngày' placement='bottom' open={open} onClose={onClose}>
        <Space direction='vertical' style={{ width: '100%' }} size={8}>
          {showCustom ? (
            <>
              <Flex vertical gap={4}>
                <Text type='secondary'>Ngày bắt đầu</Text>
                <DatePickerMobile
                  {...datePickerProps}
                  value={customStart}
                  onChange={(date) => setCustomStart(date)}
                  disabledDate={disableStartDate}
                  format={displayFormat}
                />
              </Flex>

              <Flex vertical gap={4}>
                <Text type='secondary'>Ngày kết thúc</Text>
                <DatePickerMobile
                  {...datePickerProps}
                  value={customEnd}
                  onChange={(date) => setCustomEnd(date)}
                  disabledDate={disableEndDate}
                  format={displayFormat}
                />
              </Flex>

              <Flex gap={8}>
                <Button block onClick={() => setShowCustom(false)}>
                  Quay lại
                </Button>
                <Button type='primary' block disabled={!customStart || !customEnd || customEnd.isBefore(customStart, 'day')} onClick={onApplyCustom}>
                  Áp dụng
                </Button>
              </Flex>
            </>
          ) : (
            <>
              {presets.map((preset) => (
                <Button key={preset.label} block onClick={() => onSelectPreset(preset.value)}>
                  {preset.label}
                </Button>
              ))}

              <Divider style={{ margin: '8px 0' }} />

              <Button block onClick={onOpenCustom}>
                Tuỳ chỉnh
              </Button>
            </>
          )}
        </Space>
      </Drawer>
    </>
  );
};

export default DateRangePickerMobile;
